module.exports = __webpack_public_path__ + "static/media/CD__0002_0001.88535a50.png";